<template>
  <div class="log">
    <button
      type="button"
      color="orange"
      outline
      class="pay-ass-btn green-button pb-1"
      @click.stop="dialog = false"
      @click="check()"
    >
      Edit
    </button>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800"
      class="layout__spacing"
    >
      <v-form
        ref="form"
        onsubmit="return false;"
        class="layout__spacing"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title
            style="
              background-color: #f5f5f5;
              padding-bottom: 5px;
              padding-top: 5px;
            "
          >
            <span class="headline"
              >Edit Final Payment(Assignment ID
              {{ assignDetails.assignmentId }})</span
            >
            <v-spacer></v-spacer>
            <v-btn icon :disabled="processing" @click.prevent="close()">
              <v-icon class="heading grey--text text--darken-4">close</v-icon>
            </v-btn>
          </v-card-title>
          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="processing"
          ></v-progress-linear>
          <v-spacer style="max-height: 550px !important">
            <v-card-text>
              <v-layout class="pb-3">
                <v-flex xs12 md12>
                  <div class="sub-heading muted">
                    Driver’s Payment credit period :
                    <span style="color: black" class="heading">
                      {{
                        driverCreditDuration !== 0 &&
                        driverCreditDuration !== undefined
                          ? driverCreditDuration
                          : "N.A"
                      }}
                      {{
                        driverCreditDuration !== 0 &&
                        driverCreditDuration !== undefined
                          ? "days"
                          : ""
                      }}</span
                    >
                  </div>
                </v-flex>
              </v-layout>
              <v-layout class="pb-3">
                <v-flex xs4 md4>
                  <div class="sub-heading muted">
                    Total Driver Price :

                    <span style="color: black" class="heading"
                      >{{
                        assignDetails.paymentAmount &&
                        assignDetails.totalAdditionalAmount
                          ? assignDetails.paymentAmount +
                            assignDetails.totalAdditionalAmount
                          : assignDetails.paymentAmount
                      }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4 md4>
                  <div class="sub-heading muted">
                    Driver Price :
                    <span style="color: black" class="heading"
                      >{{ assignDetails.paymentAmount }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4 md4>
                  <div class="sub-heading muted">
                    Additional Charges :
                    <span style="color: black" class="heading break-word">
                      {{ assignDetails.totalAdditionalAmount || "0" }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
              </v-layout>
              <v-layout class="pb-3">
                <v-flex xs4 md4>
                  <div class="sub-heading muted break-word">
                    Advance Paid :
                    <span style="color: black" class="heading"
                      >{{ assignDetails.totalAdvancePaidAmount || "0" }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4 md4>
                  <div class="sub-heading muted break-word">
                    Amount Paid Till Date:
                    <span style="color: black" class="heading"
                      >{{
                        assignDetails.amountPaidToDriver +
                          assignDetails.totalAdvancePaidAmount || "0"
                      }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
                <v-flex xs4 md4>
                  <div class="sub-heading muted break-word">
                    Pending Amount :
                    <span style="color: black" class="heading"
                      >{{ PendingAmount.toFixed(2) || "0" }}
                      {{ assignDetails.customerCurrency }}</span
                    >
                  </div>
                </v-flex>
              </v-layout>

              <v-layout class="payment-popup-toolbar" wrap>
                <v-flex xs12 md7>
                  <SegmentedControl
                    v-model="tabStatus"
                    class="payment-popup-tabs"
                    aria-label="Edit final payment sections"
                    :options="editPendingAmountTabOptions"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md5
                  class="pr-1 pt-2 pb-3 pt-100"
                  v-if="document.length < 10"
                >
                  <div
                    class="noBorder upload-btn-wrapper"
                    style="border: 0px !important"
                  >
                    <button v-if="document.length < 10" class="btn">
                      <v-icon small color="orange">upload</v-icon> Upload Proof
                      Of Payment
                    </button>
                    <input
                      ref="fileUpload"
                      id="fileUpload"
                      type="file"
                      multiple
                      accept=".pdf, .jpeg, .jpg, .png"
                      @change="uploadDocument"
                    />
                  </div>
                </v-flex>
              </v-layout>

              <v-layout v-if="tabStatus === 'Driver'">
                <v-flex xs12 md12>
                  <v-radio-group
                    class="mt-0 pt-0"
                    v-model="paymentMode"
                    row
                    :mandatory="true"
                    readonly
                  >
                    <div>
                      <div class>
                        <v-layout>
                          <v-radio
                            label="Cash"
                            value="Cash"
                            color="orange"
                            class="col-md-6"
                          ></v-radio>

                          <v-radio
                            label="Bank Transfer"
                            value="Bank Transfer"
                            color="orange"
                            class="col-md-6"
                          ></v-radio>
                        </v-layout>
                      </div>
                    </div>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <!-- <v-layout v-if="tabStatus === 'Driver'">
                <v-flex md5 class="payadvance">
                  <v-flex md12 pb-3>
                    <v-text-field
                      v-model="accountHolderName"
                      label="Account Holder Name"
                      placeholder="Enter account holder name"
                      class="pt-0 currencyTitle"
                      :value="accountHolderName"
                      readonly
                    ></v-text-field>
                  </v-flex>

                  <v-layout>
                    <v-flex md12 class="payadvance">
                      <v-text-field
                        v-model="ifscCode"
                        label="IBAN Number"
                        placeholder="Enter IBAN number"
                        class="pt-0 currencyTitle"
                        readonly
                        maxlength="25"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md6 pl-5 class="payadvance">
                  <v-layout>
                    <v-flex md12 pb-3 class="payadvance">
                      <v-text-field
                        v-model="accountNumber"
                        label="Account Number"
                        placeholder=" Enter Account Number"
                        class="pt-0 currencyTitle"
                        readonly
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-layout>
                      <v-flex md12 class="payadvance">
                        <v-text-field
                          v-model="swiftNumber"
                          label="Swift Number"
                          class="pt-0 currencyTitle"
                          placeholder="Enter Swift Number"
                          :value="swiftNumber"
                          readonly
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-flex>
              </v-layout> -->

              <v-layout v-if="tabStatus === 'Debtor'">
                <v-flex xs12 md12>
                  <v-radio-group
                    class="mt-0 pt-0"
                    v-model="debtorPaymentMode"
                    row
                    :mandatory="true"
                    :rules="[rules.required]"
                    @change="
                      bankName = '';
                      getBankName();
                    "
                  >
                    <div>
                      <div class>
                        <v-layout>
                          <v-radio
                            label="Cash"
                            value="Cash"
                            color="orange"
                            class="col-md-6"
                          ></v-radio>

                          <v-radio
                            label="Bank Transfer"
                            value="Bank Transfer"
                            color="orange"
                            class="col-md-6"
                          ></v-radio>
                        </v-layout>
                      </div>
                    </div>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout v-if="tabStatus === 'Debtor'">
                <v-flex xs5 sm5 v-if="debtorPaymentMode === 'Cash'">
                  <v-autocomplete
                    v-if="
                      assignDetails.customerCurrency === 'AED' ||
                      assignDetails.customerCurrency === 'SAR'
                    "
                    label="Select Cash"
                    placeholder="Select Cash"
                    :items="banks"
                    class="pt-0 currencyTitle"
                    v-model="bankName"
                    :disabled="
                      !this.$props.invoiceCity || !this.$props.invoiceCompany
                    "
                    item-text="text"
                    item-value="value"
                    :rules="[rules.selectCash]"
                  />

                  <v-text-field
                    v-if="assignDetails.customerCurrency == 'PKR'"
                    v-model="bankName"
                    label="Select Cash"
                    class="pt-0 currencyTitle"
                    placeholder="Debitor Bank Name"
                    :value="bankName"
                    :rules="[rules.selectCash]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs5 sm5 v-else>
                  <v-autocomplete
                    v-if="
                      assignDetails.customerCurrency === 'AED' ||
                      assignDetails.customerCurrency === 'SAR'
                    "
                    label="Choose Debtor Bank"
                    placeholder="Choose Debtor Bank"
                    :items="banks"
                    class="pt-0 currencyTitle"
                    v-model="bankName"
                    :disabled="
                      !this.$props.invoiceCity || !this.$props.invoiceCompany
                    "
                    item-text="text"
                    :rules="[rules.debtorBank]"
                    item-value="value"
                  />

                  <v-text-field
                    v-if="assignDetails.customerCurrency == 'PKR'"
                    v-model="bankName"
                    label="Debitor Bank Name"
                    class="pt-0 currencyTitle"
                    placeholder="Debitor Bank Name"
                    :value="bankName"
                    :rules="[rules.noWhiteSpace, rules.debtorBankName]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm6 md6 pl-5>
                  <div class="heading">
                    <v-text-field
                      style="padding-top: 2px"
                      label="Amount To be Paid"
                      placeholder="Amount To be Paid"
                      :suffix="priceData.customerCurrency"
                      v-model="driverAmount"
                      class="pt-0 currencyTitle"
                      :rules="[rules.amountToBePaid, rules.minamount]"
                    />
                  </div>
                </v-flex>
              </v-layout>
              <v-layout v-if="tabStatus === 'Debtor'">
                <v-flex xs5 pt-3>
                  <span class="muted"></span>
                  <v-menu
                    ref="FilterDateBool"
                    lazy
                    v-model="FilterDateBool"
                    class="date__icon"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="startDate"
                  >
                    <v-text-field
                      slot="activator"
                      :label="'Select Actual Date '"
                      placeholder="Select Actual Date"
                      v-model="startDate"
                      prepend-icon="event"
                      readonly
                      class="pt-0 currencyTitle"
                      :rules="[rules.date]"
                    ></v-text-field>
                    <v-date-picker
                      v-model="startDate"
                      :max="dateToday"
                      class="minHeight"
                      @change="$refs.FilterDateBool.save(startDate)"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs5 pl-5 style="position: relative">
                  <label
                    :class="
                      actualModeError
                        ? 'light_red label__position__acc muted'
                        : 'label__position__acc muted'
                    "
                    style="font-size: 10px !important"
                    >Select Actual Time</label
                  >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    :class="
                      actualModeError
                        ? 'light_red_fill clock_account_pay'
                        : 'clock_account_pay'
                    "
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path
                      d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                    />
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                  </svg>
                  <vue-timepicker
                    class="fonttime"
                    :minute-interval="30"
                    v-model="pickupTime"
                    input-width="28em"
                    :label="'Select Actual Time'"
                    placeholder="Select Actual Time"
                    close-on-complete
                    :rules="[rules.required]"
                  ></vue-timepicker>
                  <span
                    v-if="actualModeError"
                    style="
                      color: #ff5252 !important;
                      width: 50%;
                      border: 0px;
                      margin: auto;
                      text-align: center;
                      font-size: 12px;
                    "
                    >Select Actual Time is required</span
                  >
                </v-flex>
              </v-layout>

              <v-layout v-if="tabStatus === 'Debtor'">
                <v-flex xs12 md12 class="pr-4">
                  <v-text-field
                    :rules="[rules.comment]"
                    class="pt-0 currencyTitle"
                    label="Comments"
                    placeholder="Comments"
                    v-model="Comments"
                  />
                </v-flex>
              </v-layout>

              <v-layout>
                <v-card-text class="nospace">
                  <v-container class="p-16">
                    <v-flex xs12 pt-2>
                      <ul style="padding: 0px !important">
                        <li
                          style="position: relative"
                          :key="i"
                          v-for="(doc, i) in document"
                          class="list"
                          ref="documentList"
                        >
                          <button
                            type="button"
                            v-show="document"
                            @click="removeImage(i)"
                          >
                            <span class="close imageClose">&times;</span>
                          </button>
                          <a
                            :href="doc"
                            class="document-link"
                            v-if="
                              doc.substr(doc.lastIndexOf('.') + 1) === 'pdf'
                            "
                            target="_blank"
                          >
                            <img src="../../../assets/pfd.png" />
                          </a>
                          <a
                            :href="doc"
                            class="document-link"
                            target="_blank"
                            v-else
                          >
                            <img
                              src="../../../assets/docimg.webp"
                              height="72"
                              width="75"
                            />
                          </a>
                        </li>
                      </ul>
                    </v-flex>
                  </v-container>
                </v-card-text>
              </v-layout>
            </v-card-text>
          </v-spacer>
          <v-card-actions>
            <!-- <v-container>
                    
                </v-container> -->
            <v-layout>
              <v-spacer />
              <v-btn flat @click.native="close()">Close</v-btn>
              <v-btn
                :loading="processing"
                color="orange darken-2"
                class="white--text"
                @click="submit()"
                >Edit</v-btn
              >
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
      <v-snackbar
        :timeout="3000"
        bottom
        color="red darken-2"
        v-model="error"
        class="white--text"
        v-if="error"
        >{{ error }}</v-snackbar
      >
    </v-dialog>
  </div>
</template>

<script>
import { StorageKeys } from "../../../constants/constants";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import moment from "moment";
import {
  addProofOfDelivery,
  uploadImage,
} from "../../../constants/api-urls.js";
import SegmentedControl from "@/components/Common/SegmentedControl.vue";
export default {
  data() {
    return {
      actualModeError: false,
      paymentMode: "",
      tabStatus: "Debtor",
      dateToday: moment(new Date()).format("YYYY-MM-DD"),
      paymentType: null,
      accountHolderName: "",
      swiftNumber: "",
      startDate: "",
      FilterDateBool: false,
      pickupTime: {
        HH: "",
        mm: "",
      },
      draftNo: "",
      accountNumber: "",
      ifscCode: "",
      advanceAmount: "",
      debtorPaymentMode: "Cash",
      banks: [],
      loading: false,
      Comments: "",
      cheque: "",
      draftNo: "",
      operationName: "",
      processing: false,
      advanceAmount: "",
      dialog: false,
      voucher: "",
      document: [],
      valid: true,
      lazy: false,
      documents: [],
      error: null,
      driverAmount: "",
      x: {
        error: null,
      },
      banks: [],
      bankName: "",
      rules: {
        required: (value) => !!value || "This field is required.",
        debtorBank: (value) => !!value || "Debator Bank is required.",
        debtorBankName: (value) => !!value || "Debator Bank Name is required.",
        amountToBePaid: (value) => !!value || "Amount To be Paid is required.",
        selectCash: (value) => !!value || "Select Cash field  is required.",
        date: (value) => !!value || " Select Actual Date is required.",
        comment: (value) => value != "" || " Comment  is required.",
        noWhiteSpace: (v) =>
          (v != null && v.trim().length > 0) || "Enter valid value.",
        amount: (v) =>
          /^\d*(\.\d+)?$/.test(v) || "Enter a valid amount. E.g 10 or 10.20",
        number: (v) => /^[0-9]*$/.test(v) || "Please enter valid amount",
        minamount: (v) => (v && v >= 1) || "Enter valid value",
      },
    };
  },
  created() {
    //this.getBankName();
  },
  props: {
    priceData: Object,
    invoiceCity: String,
    invoiceCompany: String,
    driverCreditDuration: String,
    assignDetails: Object,
    PendingAmount: Number,
  },
  watch: {
    pickupTime() {
      if (this.pickupTime) {
        this.actualModeError = false;
      } else {
        this.actualModeError = true;
      }
    },
  },
  components: {
    VueTimepicker,
    SegmentedControl,
  },
  computed: {
    editPendingAmountTabOptions() {
      return [{ label: "Debtor Payment Details", value: "Debtor" }];
    },
  },
  methods: {
    getDetails() {
      this.getBankName();
    },
    checkTime() {
      let re = /^\d{1,2}:\d{2}([ap]m)?$/;
      var time =
        this.pickupTime.HH && this.pickupTime.mm
          ? this.pickupTime.HH + ":" + this.pickupTime.mm
          : this.pickupTime;

      if (time != "" && !time.match(re)) {
        this.processing = false;
        this.error = "Please select the valid time before moving ahead!";
        this.actualModeError = true;

        return false;
      }
    },
    async check() {
      this.processing = true;
      this.operationName = "pending-amount-for-driver-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.processing = false;
        this.open();
      } else {
        this.processing = false;
        return;
      }
    },

    open() {
      this.getBankName();
      if (
        this.assignDetails.assetId &&
        this.assignDetails.imeiInstallStatus &&
        this.assignDetails.imeiInstallStatus != "collected"
      ) {
        this.dialog = false;
        this.error = "Kindly collect the gps device";
      } else if (
        this.assignDetails.assetId &&
        !this.assignDetails.imeiInstallStatus
      ) {
        this.dialog = false;
        this.error = "Kindly collect the gps device";
      } else {
        this.tabStatus = "Debtor";
        this.debtorPaymentMode = this.priceData.modeOfPayment;
        this.driverAmount = Number(this.priceData.amount);
        this.startDate = moment(this.priceData.paidDate).format("YYYY-MM-DD");
        this.pickupTime = this.priceData.paidTime;

        this.bankName = this.priceData.bankName;
        if (this.priceData.modeOfPayment === "Demand Draft") {
          this.draftNo = this.priceData.draftNo;
        }
        this.paymentMode = this.assignDetails.creditorPaymentMode;
        this.ifscCode = this.assignDetails.creditorIBANNumber;

        this.swiftNumber = this.assignDetails.creditorSwiftNo;

        this.accountHolderName = this.assignDetails.creditorAccountHolderName;

        this.accountNumber = this.assignDetails.creditorAccountNumber;

        this.voucher = this.assignDetails.creditorVoucherNo;

        this.draftNo = this.assignDetails.creditorDraftNo;

        this.cheque = this.assignDetails.creditorChequeNo;
        this.document = this.priceData.proof ? this.priceData.proof : [];
        this.Comments = this.priceData.comment ? this.priceData.comment : "";
        this.dialog = true;
      }
    },
    getBankName() {
      if (
        this.$props.invoiceCompany == "2" &&
        this.debtorPaymentMode == "Cash"
      ) {
        // this.bankName = "Cash";
        this.banks = [];
        this.banks = ["Cash"];
      } else {
        // if (this.$props.invoiceCompany == "1") {
        this.banks = [];
        let obj = {
          Cash: "cash",
          "Bank Transfer": "bankTransfer",
        };
        console.log(obj[this.debtorPaymentMode]);

        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          country: this.$props.invoiceCompany,
          modeOfPayment:
            this.$props.invoiceCompany == "2"
              ? "bankTransfer"
              : obj[this.debtorPaymentMode],
        };
        let { apiUrl } = this.constants;
        this.axios
          .post(`${apiUrl}/dmsAdmin/get-ledger-details`, body, config)
          .then(
            (response) => {
              const { data = null } = response.data;
              console.log(response.data);
              data.forEach((element) => {
                console.log(element);
                this.banks.push({
                  text: element.ledgerName,
                  value: element.ledgerName,
                });
              });

              // this.bankName = response.data.data[2].bankName;
              // this.banks = response.data.data;
            },
            (error) => {
              this.error = "Something went wrong. Please try again later!";
              this.loading = false;
            }
          );
      }
      // } else if (
      //   this.$props.invoiceCompany == "2" &&
      //   (this.$props.invoiceCity == "1" || this.$props.invoiceCity == "2")
      // ) {
      //   this.banks = ["Mashreq Bank PSJC", "EMIRATES NBD Bank", "ADCB -  0001"];
      // } else {
      //   return;
      // }
    },

    removeImage(key) {
      this.document.splice(key, 1);
    },
    uploadDocument(e) {
      this.error = null;
      var files = e.target.files || e.dataTransfer.files;
      let x = [...files];
      setTimeout(() => {
        this.$refs.fileUpload.value = "";
      }, 6000);
      if (!files.length) return;

      Array.from(x).forEach((y, i) => {
        this.createImage(files[i]);
      });
    },
    createImage(file) {
      let size = file.size / 1024 / 1024;
      // -------- FILE SIZE CHECK
      if (size > 5) {
        this.error = "Please upload proof with size less than 5MB!";

        return false;
      }
      if (
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/png" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpeg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !==
          "application/pdf"
      ) {
        this.error = "Please upload proof of file type png , jpg ,jpeg or pdf!";
        return false;
      } else {
        var image = new Image();
        var reader = new FileReader();
        var vm = this;

        reader.onload = (e) => {
          vm.image = e.target.result;
        };
        reader.readAsDataURL(file);
        this.upload(file);
      }
    },
    upload(file) {
      this.processing = true;
      const formData = new FormData();
      formData.append("image", file);
      this.axios({
        url: `${this.constants.apiUrl}${uploadImage}`,
        method: "POST",
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(
        (response) => {
          this.processing = false;
          const { statusCode } = response.data;
          if (statusCode === 200) {
            if (this.document.length < 10) {
              this.document.push(response.data.data.original);
            } else {
              this.error = "Maximum 10 proofs can be uploaded!";
              return false;
            }
          } else {
            this.error = "Failed to upload image";
          }
          this.loading = false;
        },
        (error) => {
          this.error = "Failed to upload image";
          this.processing = false;
        }
      );
    },

    close() {
      this.actualModeError = false;

      this.dialog = false;
      this.paymentMode = "Cash";
      (this.Comments = ""),
        (this.pickupTime = {
          HH: "",
          mm: "",
        }),
        (this.bankName = "");
      this.draftNo = "";
      this.cheque = "";
      this.voucher = "";
      this.ifscCode = "";
      this.accountHolderName = "";
      this.accountNumber = "";
      this.startDate = "";
      this.driverAmount = this.priceData.amount;
      this.error = null;
      this.document = [];
      this.$refs.form.resetValidation();

      this.$eventBus.$emit("close-confirmation-dialog");
    },

    settleFNF() {
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const url = `${this.constants.apiUrl}/dmsAdmin/settleFnfRequest`;
      this.axios
        .post(
          url,
          {
            assignmentId: this.assignmentId.toString(),
          },
          config
        )
        .then((response) => {
          this.loading = false;
          return true;
        })
        .catch((e) => {
          this.error = "Payment failed. Try again later";
          return false;
        });
    },
    async submit() {
      this.processing = true;
      this.operationName = "pending-amount-for-driver-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.error = null;
        this.loading = true;

        if (this.$refs.form.validate()) {
          if (this.debtorPaymentMode === "Bank Transfer" && !this.bankName) {
            this.loading = false;
            this.processing = false;
            this.error = "Please fill debtor details!";
            return false;
          }
          if (
            !this.debtorPaymentMode ||
            !this.driverAmount ||
            !this.startDate ||
            !this.Comments ||
            this.pickupTime === { HH: "", mm: "" } ||
            !this.pickupTime ||
            !this.driverAmount
          ) {
            this.loading = false;
            this.processing = false;
            this.error = "Please fill debtor details!";
            return false;
          }
          let greaterAmount =
            Number(this.PendingAmount) + Number(this.priceData.amount);
          if (Number(this.driverAmount) > greaterAmount) {
            this.loading = false;
            this.processing = false;

            // this.error =
            //   "Amount to be paid can't be greater than pending amount!";
            this.error = `You cannot pay greater than ${greaterAmount} ${this.assignDetails.customerCurrency} amount to the driver`;

            return false;
          }

          if (!this.pickupTime) {
            this.actualModeError = true;
            return false;
          }
          if (this.pickupTime) {
            this.checkTime();
            this.actualModeError = false;

            let currentDate = moment(new Date()).format("YYYY-MM-DD, HH:mm");
            let selectedDateTime = this.startDate + "," + this.pickupTime;

            if (
              new Date(currentDate).getTime() <
              new Date(selectedDateTime).getTime()
            ) {
              this.loading = false;
              this.processing = false;
              this.error =
                "Please select the past time and date before moving ahead!";
              return false;
            }
          }
          if (!this.document.length) {
            this.error = "Please upload proof ";
            this.processing = false;
            this.loading = false;
            return false;
          }
          let url = `/dmsAdmin/edit-assignment-payment/${this.priceData._id}`;

          delete this.axios.defaults.headers.common["token"];
          let token = localStorage.getItem(StorageKeys.SessionKey);
          let config = {
            headers: {
              authorization: `bearer ${token}`,
            },
          };
          const body = {
            assignmentId: this.priceData.assignmentId,

            paymentMode: this.debtorPaymentMode.toString(),
            amount: this.driverAmount.toString(),
            paidDate: this.startDate,
            paidTime: this.pickupTime,
            paymentAmount: this.assignDetails.paymentAmount.toString(),

            comment: this.Comments.trim(),
          };
          if (this.bankName) {
            body.bankName = this.bankName;
          }
          if (this.document.length) {
            body.proof = this.document;
          }

          this.axios.put(this.constants.apiUrl + url, body, config).then(
            (response) => {
              // this.x.success = true;
              this.dialog = false;
              this.processing = false;
              this.close();
              this.paymentMode = "";
              this.$emit("payment-list-refresh");
              this.error = "";
            },
            (error) => {
              this.processing = false;
              this.error = error.response.data.message;
            }
          );
        } else {
          this.processing = false;
        }
      } else {
        //this.error = "All fields are mandatory";
        this.processing = false;
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.break-word {
  word-break: break-all;
}
.pay-ass-btn {
  text-decoration: none;
  color: #ea7a1c;
  border: 2px solid #ea7a1c;
  padding: 4px 10px;
  border-radius: 5px;
}
.pay-not-ass-btn {
  text-decoration: none;
  color: lightgray;
  border: 2px solid lightgray;
  padding: 4px 12px;
  border-radius: 5px;
}
.custom-file-upload {
  border: none;
  display: inline-block;
  background: #ea7a1c;
  font-size: 16px;
  color: #fff;
  padding: 10px 12px;
  cursor: pointer;
}
.document-link {
  text-decoration: none;
}
.payment-popup-toolbar {
  align-items: flex-start;
  gap: 0.75rem;
  overflow: visible;
}
.payment-popup-tabs {
  margin-bottom: 1.25rem;
}
.vue__time-picker input.display-time {
  border-radius: 0px !important;
  border-bottom: 1px solid #d2d2d2 !important;
  border: none;
  padding: 0px !important;
}
.fonttime {
  font-size: 12px !important;
}
.list {
  display: inline-block;
  position: relative;
}
.fonttime .dropdown.drop-down {
  top: -14%;
}
</style>
